<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-panel header="{{ 'BANCOERROR.LBL_BANCOERRORES' | translate}}">
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'BANCOERROR.LBL_CODIGO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{bancoError.codigo}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'BANCOERROR.LBL_INTEGRACION' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{bancoError.integracion}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'BANCOERROR.LBL_DESUSUARIO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{bancoError.descripcionUsuario}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'BANCOERROR.LBL_DESTECNICA' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{bancoError.descripcionTecnica}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'LBL_HABILITADO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{bancoError.indicadorHabilitado ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>
        <div class="grid form-footer-buttons">
          <div class="form-group col-12">
            <button icon="fa fa-arrow-left" label="{{'BTN_REGRESAR' | translate }}"
                    type="submit" (click)="regresar()"
                    pButton></button>
          </div>
        </div>
      </p-panel>
    </div>
  </div>
</div>
<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
